import { z } from "zod";

export const mailIntakeItemSchema = z.object({
  id: z.string(),
  batchId: z.string(),
  fileId: z.string().nullable(),
  name: z.string(),
  uploadedByDisplayName: z.string().nullish(),
  status: z.enum([
    "uploading",
    "queued",
    "preparing",
    "processing_pages",
    "describing",
    "sorting",
    "filing",
    "filed",
    "needs_attention",
    "failed",
  ]),
  progress: z.number(),
  processedPages: z.number(),
  totalPages: z.number().nullable(),
  message: z.string().nullable(),
  errorCode: z.string().nullable(),
  canRetry: z.boolean(),
  canMove: z.boolean(),
  revision: z.number().nullable(),
  destination: z
    .object({
      folderId: z.string(),
      folderName: z.string(),
      matterId: z.string().nullable(),
      matterName: z.string().nullable(),
      scope: z.string(),
    })
    .nullable(),
  dateCreated: z.string(),
});
export const mailIntakeListSchema = z.object({
  data: mailIntakeItemSchema.array(),
  nextCursor: z.string().nullable(),
});
export type MailIntakeItem = z.infer<typeof mailIntakeItemSchema>;
export const isMailIntakeActive = (item: Pick<MailIntakeItem, "status">) =>
  !["filed", "needs_attention", "failed"].includes(item.status);
